/**
 * created by yxy
 *
 */
import React, {Component} from 'react';
import BaseComponent from "../../../../../base/BaseComponent";
import PropTypes from 'prop-types';
import PageTemplate from "../../../components/pageTemplate/PageTemplate";
import beian from '../images/beian.png'
import review from  '../images/review.png'
import activation from '../images/activation.png'
import {picList} from '../config/config'
export default class MediaStatus extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            statistics:{},
            statisticsList:[]
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getData();
        this.getList()

    }
    getData = () =>{
       this.request({
           url: '/cm-sites-media-consumer/position/overview/statistics',
           method: "get",
           callBack: (data) => {
               let statistics = {};
             if(data){
                 statistics = data
             }
             this.setState({statistics})
           }
       });
   };

    getList = () =>{
        this.request({
            url: '/cm-sites-media-consumer/position/overview/positionActivity',
            method: "get",
            callBack: (data) => {
                let statisticsList = [];
                if(data&&data.length){
                    statisticsList = data
                }
                this.setState({statisticsList})
            }
        });
    };


    render() {
        let {statisticsList} = this.state;
        let processTypeImage =  this.sysConfigGetValueByKey('processTypeImage', '[]')
       let picListNew = picList.concat(...JSON.parse(processTypeImage));
        return (
            <PageTemplate style={{padding:'0px',background:'none'}} styleOut={{margin:'0px 15px'}}>
            <div style={{display: 'flex', flexWrap: "noWrap", marginBottom: 15, justifyContent: "space-between"}}>
                <div style={{
                    display: "flex",
                    width: 480,
                    height: 84,
                    background: "linear-gradient(180deg, #37D99F 0%, #28BC88 100%)",
                    borderRadius: "5px",
                    marginRight: 8,
                    opacity: 1,
                    color: "#fff"
                }}>
                    <div style={{maxWidth: 240,minWidth:115, display: "flex", alignItems: "center",justifyContent: "space-evenly",flex: "1 1 240px"}} onClick={() => {
                        // window.location.hash = '/view/newMediaMatrix/pms/newMediaMatrix/mediaManagement';
                    }}>
                        <div style={{}}><img alt={""} src={beian}  style={{display: "block"}}/></div>
                        <div style={{ fontSize: "14px"}}>已备案</div>
                        <div style={{ fontSize: "20px"}}>{this.state.statistics.recordedCount}</div>
                    </div>
                    <div style={{width: 1, height: 60, background: "#fff", opacity: 0.4, margin: "11px auto"}}/>
                    <div style={{maxWidth: 240,minWidth:115, display: "flex", alignItems: "center",justifyContent: "space-evenly",flex: "1 1 240px"}}>
                        <div style={{}}><img alt={""} src={activation} style={{display: "block"}}/></div>
                        <div style={{ fontSize: "12px", opacity: 1}}>近期活跃</div>
                        <div style={{ fontSize: "16px", opacity: 1}}>{this.state.statistics.activatingCount}</div>
                    </div>
                </div>
                <div style={{
                    display: "flex",
                    width: 1096,
                    height: 84,
                    background: "linear-gradient(180deg, #58B0FB 0%, #3F99F3 100%)",
                    borderRadius: "5px",
                    opacity: 1,
                    color: "#fff"
                }}>
                    <div style={{maxWidth: 250,minWidth:115, display: "flex", alignItems: "center",justifyContent: "space-evenly",flex: "1 1 250px"}} onClick={() => {
                        this.auditing()
                    }}>
                        <div style={{}}><img alt={""} src={review}  style={{display: "block"}}/></div>
                        <div style={{ fontSize: "14px"}}>审核中</div>
                        <div style={{ fontSize: "20px"}}>{this.state.statistics.recordingCount}</div>
                    </div>
                    <div style={{width: 1, height: 60, background: "#fff", opacity: 0.4, margin: "11px 0"}}/>
                    <div style={{width:"100%",display:"flex",flexWrap: "nowrap"}}>
                        {statisticsList&&statisticsList.length > 0&&statisticsList.map((item,index)=>{
                            let src ='';
                            picListNew.forEach(i=>{
                                if(i.name === item.name){
                                    src = i.src
                                }
                            });
                            return(
                                <div style={{display:'flex',flex: "1 1 171px",minHeight:90}} key={index}>
                                    <div style={{maxWidth: 170,minWidth:89, display: "flex", alignItems: "center",flex: "1 1 170px",justifyContent: "center"}}>
                                        <div><img alt={""} src={src}  style={{display: "block"}}/></div>
                                        <div style={{ fontSize: "12px", opacity: 1,marginLeft:4}}>{item.name}</div>
                                        <div style={{ fontSize: "16px", opacity: 1,marginLeft:15}}>{item.count}</div>
                                    </div>
                                    <div style={{
                                        width: 1,
                                        height: 24,
                                        background: "#fff",
                                        opacity: 0.4,
                                        margin: "30px auto",
                                        borderRadius: "5px",
                                    }}/>
                                </div>
                            )
                        })}
                    </div>





                </div>
            </div>
            </PageTemplate>
        )
    }

}